export const CHART_GENERAL_HEIGHT = "280px";
